import React from "react";

const Slider = ({ label, value, min, max, step = 1, onChange }) => {
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="a11y-slider-wrapper">
      <div className="a11y-slider-label">
        <span>{label}</span>
      </div>

      <div className="a11y-slider-container">
        <div
          className="a11y-slider-progress"
          style={{
            width: `${percentage}%`,
          }}
        />

        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="a11y-slider"
        />
      </div>
    </div>
  );
};

export default Slider;
